webpackJsonp([211051504594766],{

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(514);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VideoBlock = function VideoBlock(_ref) {
		var title = _ref.title,
		    link = _ref.link,
		    description = _ref.description;
	
		return _react2.default.createElement(
			'div',
			{ className: 'VideoBlock' },
			_react2.default.createElement(
				'h3',
				{ className: 'VideoBlock-title' },
				title
			),
			description && _react2.default.createElement(
				'div',
				{ className: 'VideoBlock-description' },
				description
			),
			_react2.default.createElement(
				'div',
				{ className: 'VideoBlock-link' },
				_react2.default.createElement('iframe', {
					src: link,
					frameBorder: '0',
					allowFullScreen: true })
			)
		);
	};
	
	VideoBlock.defaultValues = {
		link: 'https://www.youtube.com/embed/V_6hy3SCNt0'
	};
	
	VideoBlock.propTypes = {
		link: _propTypes2.default.string.isRequired,
		title: _propTypes2.default.string,
		description: _propTypes2.default.string
	};
	
	exports.default = VideoBlock;
	module.exports = exports['default'];

/***/ }),

/***/ 514:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PageHeader = __webpack_require__(34);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _VideoBlock = __webpack_require__(244);
	
	var _VideoBlock2 = _interopRequireDefault(_VideoBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Videos = function Videos(_ref) {
	  var data = _ref.data;
	
	
	  var videos = data.videosMarkdown.edges;
	
	  var renderVideos = function renderVideos(videos) {
	    return Object.keys(videos).map(function (video) {
	
	      var currentVideo = videos[video].node;
	      var _currentVideo$frontma = currentVideo.frontmatter,
	          title = _currentVideo$frontma.title,
	          link = _currentVideo$frontma.link,
	          description = _currentVideo$frontma.description;
	
	
	      return _react2.default.createElement(_VideoBlock2.default, {
	        key: video,
	        title: title,
	        link: link,
	        description: description
	      });
	    });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'videos' },
	    _react2.default.createElement(
	      'div',
	      { className: 'main' },
	      _react2.default.createElement(_PageHeader2.default, { title: 'Retrouvez ici toutes nos vid\xE9os' }),
	      renderVideos(videos)
	    )
	  );
	};
	
	Videos.PropTypes = {
	  data: _propTypes2.default.object
	};
	
	exports.default = Videos;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-videos-jsx-d7295d17a825ee7010e1.js